import React from "react";
import "./noEnrollmentFoundCard.css";
import { notFound } from "../../../../../../../../assets";

type NoEnrollmentFoundCardProps = {
	title?: string;
};

const NoEnrollmentFoundCard = ({ title = "No VEB Plans Found" }: NoEnrollmentFoundCardProps) => {
	return (
		<div className="category-card">
			<div className="img-container">
				<img src={notFound} alt="No Available Enrollment Plans" className="not-found-img" />
			</div>
			<h2 className="title">{title}</h2>
			<h3 className="subtitle">Check back later for new opportunities</h3>
			<p className="message"></p>
		</div>
	);
};

export default NoEnrollmentFoundCard;
